import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [time, setTime] = useState(10 * 60 + 48); // 10 minutes 48 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return <div className="fixed top-0 left-0 w-full bg-red-600 text-white z-50 py-2 px-4 shadow-md text-center font-bold text-sm md:text-base flex justify-center items-center gap-2 animate-pulse" data-id="element-4">
      <Clock className="w-4 h-4" data-id="element-5" />
      <span data-id="element-6">
        ESTA OFERTA TERMINA PRONTO: {String(minutes).padStart(2, '0')}:
        {String(seconds).padStart(2, '0')}
      </span>
    </div>;
}